import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Block from "@material-ui/icons/Block";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DetailsInfo from "./components/info";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useCancellationDetailsStyles } from "./styles";
import { useCancellationDetails } from "../../../services/api-tansquery/cancellation/details";


export default function AppointmentCancellationsDetails() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { classes } = useCancellationDetailsStyles();
    const { data: cancellation, isLoading } = useCancellationDetails(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Cancelamentos",
                    path: "/cancelamentos",
                    icon: Block
                },
                {
                    label: "Informações",
                    path: "",
                }
            ]
        });
    }, [setBreadcrumbs]);

    return (
        <Box className={classes.root}>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            {isLoading ? (
                <Box className={classes.loading}>
                    <span>Carregando informações...</span>  
                </Box>
            ) : <DetailsInfo cancellation={cancellation} />}
            
        </Box >
    );
}